import React from 'react';
import { Typography } from '@mui/material';
import useBattleGamePopupTStyles from '../../styles/kozelBattle/battleGamePopupT';

interface BattleGamePopupTProps {
  isOpen: boolean;
  onClose: () => void;
  score: number;
}

const BattleGamePopupT: React.FC<BattleGamePopupTProps> = ({ isOpen, onClose, score }) => {
  const classes = useBattleGamePopupTStyles();

  if (!isOpen) return null;

  return (
    <div className={classes.overlay}>
      <div className={classes.popup}>
        <Typography className={classes.felicitari}>FELICITĂRI!</Typography>

        <Typography className={classes.description}>
          Ți-ai susținut echipa și ai prins un număr impresionant de sticle KOZEL!
        </Typography>

        <span className={classes.scoreBadge}>
          {score} pct
        </span>

        <button className={classes.closeButton} onClick={onClose}>
          ÎNCHIDE
        </button>
      </div>
    </div>
  );
};

export default BattleGamePopupT;
